// Must stay above any Bifrost-side timeout so its 504 wins and names the upstream.
export const AVAILABILITY_TIMEOUT_MS = 10_000;
